import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {AppState} from "@store/state/app.state";
import {FormStatus} from "@iw-shop/forms/components/submit-button/submit-button.component";
import {ApiContactsSetRequest} from "@api/contacts";
import {ContactService} from "@iw-shop/contact/services/contact.service";

@Component({
    selector: 'iw-shop-contact-form',
    standalone: false,
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {
    @Input() type: 'contact' | 'feedback' = 'contact';
    @Input() subject?: string;
    @Input() fields: string[] = ['email', 'subject', 'message', 'company', 'name', 'firstName', 'phone', 'street', 'postcode', 'town'];
    @Input() fields_json?: string;
    @Input() fieldsRequired: string[] = ['email', 'subject', 'message'];
    @Input() fields_required_json?: string;


    form: FormGroup;

    formStatus: FormStatus = null;

    apiError?: {
        notification: string,
        errors?: { key: string, error: string }[]
    };

    captcha: boolean = false;

    constructor(protected fb: FormBuilder, protected store: Store<AppState>, protected contactService: ContactService) {
        this.form = this.fb.group({
            email: [''],
            subject: [''],
            message: [''],
            company: [''],
            name: [''],
            firstName: [''],
            phone: [''],
            street: [''],
            town: [''],
            postcode: ['']
        });
    }

    ngOnInit() {
        if (this.fields_json) {
            this.fields = JSON.parse(this.fields_json);
        }
        if (this.fields_required_json) {
            this.fieldsRequired = JSON.parse(this.fields_required_json);
        }
        if (this.subject) {
            this.form.get('subject')?.setValue(this.subject)
        }
        this.fieldsRequired.map(f => {
            if (f == 'email') {
                this.form.get(f)?.setValidators([Validators.required, Validators.email]);
            } else {
                this.form.get(f)?.setValidators([Validators.required, Validators.minLength(2)]);
            }
            this.form.get(f)?.updateValueAndValidity();
        });

    }

    isField(field: string): boolean {
        return (this.fields.includes(field));
    }

    isFieldRequired(field: string): boolean {
        return (this.fieldsRequired.includes(field));
    }

    isFormRequestError(value: string): boolean {
        let form = this.form?.get(value);
        return (
            (
                form?.errors ||
                this.isFormRequestApiError(value)
            ) &&
            this.formStatus == 'submitForm');
    }

    isFormRequestApiError(key: string): boolean {
        return !!this.apiError?.errors?.filter(r => r.key == key)[0];
    }

    setCaptcha(value: boolean) {
        setTimeout(() => {
            this.captcha = value;
        }, 100);

    }

    submit() {
        this.formStatus = 'submitForm';
        this.apiError = undefined;

        if (this.captcha && this.form.valid) {
            this.formStatus = 'loading';
            let data: ApiContactsSetRequest['params']['data'] = {
                type: this.type,
                company: this.form.get('company')?.value,
                email: this.form.get('email')?.value,
                firstName: this.form.get('firstName')?.value,
                message: this.form.get('message')?.value,
                name: this.form.get('name')?.value,
                phone: this.form.get('phone')?.value,
                subject: this.form.get('subject')?.value,
                street: this.form.get('street')?.value,
                postcode: this.form.get('postcode')?.value,
                town: this.form.get('town')?.value
            };

            this.contactService.set(data)
                .subscribe(
                    {
                        next: (r) => {
                            this.formStatus = 'submitForm';
                            if (r.error) {
                                this.apiError = {notification: r.error.message};
                                if (r.error.input) {
                                    this.apiError.errors = r.error.input;
                                }
                                window.scroll({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });
                            } else {
                                this.formStatus = 'success';
                            }
                        },
                        error: () => {
                            this.formStatus = 'submitForm';
                        }
                    });
        }
    }
}
